export function Footer() {
  return (
    <footer className="border-t border-white/[0.06] py-12">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-4 md:flex-row md:items-center md:px-6">
        <div>
          <p className="font-semibold text-white">OpenGateway</p>
          <p className="mt-1 text-sm text-white/40">
            Hosted by MR Dula Solutions · OSS core Apache-2.0
          </p>
        </div>
        <div className="flex flex-wrap gap-4 text-sm text-white/50">
          <a
            href="https://github.com/mrdulasolutions/open-gateway"
            className="hover:text-white"
            target="_blank"
            rel="noreferrer"
          >
            GitHub (OSS)
          </a>
          <a href="mailto:matt@mrdula.solutions" className="hover:text-white">
            Contact
          </a>
          <a href="#pricing" className="hover:text-white">
            Pricing
          </a>
        </div>
      </div>
    </footer>
  );
}
